<template>
    <div>
        <my-header></my-header>
        <div class="container">
            <title-picture bgimg="news_bg.jpg" text="新闻公告"></title-picture>
            <router-view></router-view>
        </div>
        <my-footer></my-footer>
    </div>
</template>
<script>
import TitlePicture from "../common/titlepicture.vue"
export default {
    components: {
        TitlePicture
    }
}
</script>







// WEBPACK FOOTER //
// src/components/news/index.vue